import { useState, useEffect } from "react";
import { HeaderVintageContainer } from "./style";
import { ContainerAuto } from "@/shared/ContainerAuto";

export const HeaderVintage = () => {
  const [scroll, setScroll] = useState(false);
  const [isDark, setIsDark] = useState(false);
  const [isMobile, setIsMobile] = useState(false); // Inicialmente en false para evitar SSR issues

  useEffect(() => {

    setIsDark(document.documentElement.getAttribute("data-theme") === "dark");
    setIsMobile(window.innerWidth <= 1024);

    const handleResize = () => setIsMobile(window.innerWidth <= 1024);
  
    window.addEventListener("scroll", () => {
      if (window.innerWidth > 1024) {
        setScroll(window.scrollY > 416);
      } else {
        setScroll(window.scrollY > 520);
      }
    });

    window.addEventListener("resize", handleResize);


    return () => {
      window.removeEventListener("resize", handleResize);

    };
  }, []);

  return (
   <HeaderVintageContainer className={scroll ? "sticky" : "no-sticky"}>
      <ContainerAuto className="container-vintage">
        <a href="/80-aniversario" className="logo-header">
          <img
            src={
              isMobile
                ? isDark
                  ? "/img/clarin-icon-80-white.png"
                  : "/img/clarin-icon-80.png"
                : "/img/clarin-icon-80.png"
            }
            width="190px"
            height="60px"
            alt="logo-80-aniversario"
          />
        </a>
      </ContainerAuto>
    </HeaderVintageContainer>
  );
};